firstmodal = {
	init: function() {
		var
			result = removeUrlParam(false, 'modal');

		if (result.value) {
			$.fancybox.open({
				src: '/local/include/modal/' + result.value,
				type: 'ajax',
				opts: {}
			});

			window.history.replaceState(null, null, result.url);
		}
	}
}



$(document).ready(function() {
	firstmodal.init();
});